import { Checkbox, CheckboxProps, Label, mergeClasses, Slider, SliderProps, useId } from "@fluentui/react-components";
import { useCallback } from "react";
import { useRenderRankingBoosterStyles } from "../styles/RenderRankingBooster.styles";

type RankingOptionType = {
  enabled: boolean;
  value: number;
  min: number;
  max: number;
  postfix: string;
};

export const RenderRankingBooster = ({
  field,
  label,
  value,
  onChange,
}: {
  field: string;
  label: string;
  value: RankingOptionType;
  onChange?: (values: Record<string, any>) => void;
}) => {
  const styles = useRenderRankingBoosterStyles();

  const onSliderChange: SliderProps["onChange"] = useCallback(
    (_, data) => {
      onChange?.({ ...value, value: data.value });
    },
    [value, onChange]
  );
  const onCheckboxChange: CheckboxProps["onChange"] = useCallback(
    (_, data) => {
      onChange?.({ ...value, enabled: data.checked as boolean });
    },
    [value, onChange]
  );

  const id = useId();

  return (
    <div className={styles.wrapperContainer}>
      <Checkbox
        checked={value.enabled}
        label={label}
        className={mergeClasses(styles.checkbox, value.enabled ? styles.checkboxChecked : "")}
        onChange={onCheckboxChange}
      />
      <div className={styles.wrapper}>
        <Slider
          disabled={!value.enabled}
          className={styles.slider}
          min={value.min}
          max={value.max}
          value={value.value}
          id={id}
          onChange={onSliderChange}
        />
        <Label aria-hidden>
          {value.value}
          {value.postfix}
        </Label>
      </div>
    </div>
  );
};
